import { useNavigate, useParams, useLocation } from 'react-router';
import { ChevronDown } from 'lucide-react';
import { useMyTenants } from '@/features/me/api';
import { useAuthStore } from '@/features/auth/auth.store';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export function TenantSwitcher() {
  const { condoId } = useParams<{ condoId?: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const session = useAuthStore((s) => s.session);
  const { data } = useMyTenants();

  if (!condoId || !data) return null;
  const current = data.items.find((t) => t.tenantId === condoId);
  if (!current) return null;

  const handleSwitch = (newTenantId: string) => {
    // Preserve module path under the new :condoId segment.
    const match = location.pathname.match(/\/app\/condominios\/[^/]+(\/.*)?/);
    const rest = match?.[1] ?? '';
    navigate(`/app/condominios/${newTenantId}${rest}`);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center gap-2 rounded-sm px-2 py-1 text-sm hover:bg-[var(--color-paper-dim)] transition-colors">
        <span className="font-semibold text-[var(--color-ink)]">{current.nombre}</span>
        <span className="text-[0.6875rem] text-[var(--color-ink-muted)]">{current.rol}</span>
        <ChevronDown className="h-3.5 w-3.5 text-[var(--color-ink-faint)]" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[14rem]">
        {data.items.map((t) => (
          <DropdownMenuItem
            key={t.tenantId}
            onSelect={() => handleSwitch(t.tenantId)}
            className={t.tenantId === condoId ? 'bg-[var(--color-paper-dim)]' : ''}
          >
            <div className="flex flex-col">
              <span className="font-semibold">{t.nombre}</span>
              <span className="text-xs text-[var(--color-ink-muted)]">{t.rol}</span>
            </div>
          </DropdownMenuItem>
        ))}
        {session?.isSuperAdmin && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onSelect={() => navigate('/app/platform')}>
              Panel plataforma
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
